import { Observable, Subject } from 'rxjs';
import { RRFilterOption } from '../../types/filter-option.type';
import { RRIFilter } from './filter.interface';

export interface RRFilterContainerModel<T> {
  activateSubmitButton: boolean;
  activateResetButton: boolean;
  addMetaButtons: Observable<any>;
  addFilterEndButtons: Observable<any>;
  hideContainer: boolean;
  changeFilterBy: Subject<T>;
  filters: RRIFilter<T, RRFilterOption<T>>[];
}
